
export default function useStyles() {
    return  theme => ({
        paper: {
            position: 'absolute',
            width: 400,
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[5],
            padding: 20,
        },
        '@media only screen and (max-width: 600px)': {
            paper: {
                width: '90%',
            },
        },
        buttonCancelar: {
            color: 'gray'
        },
        buttonRemover: {
        },
        tituloModalRemove: {
            marginBottom: '20px'
        }
    });
}